import { ref } from 'vue'
import axios from 'axios'
import { castAttributesForSnakeCase } from 'src/biz_spa/modules/string_converter'
import { useFlash } from 'src/biz_spa/composables'

type Params = {
  instagramBusinessAccountId: string
  storeUuids: string[]
  hashTags: string[]
}

export const useStoreInstagramHashTagSetting = () => {
  const isLoading = ref<boolean>(false)
  const { updateFlash } = useFlash()
  const trigger = (companyUuid: string, params: Params) => {
    if (isLoading.value) return

    isLoading.value = true
    return axios
      .post(`/api/companies/${ companyUuid }/sns/facebook/instagram_business_accounts/hash_tag_settings`, {
        settings: castAttributesForSnakeCase(params)
      })
      .then(() => {
        updateFlash({ type: 'notice', message: '保存しました。' })
      })
      .catch(err => {
        updateFlash({ type: 'alert', message: err.response.data.errors[0].detail })
      })
      .finally(() => {
        isLoading.value = false
      })
  }
  return {
    isLoading,
    trigger,
  }
}
